import React, { useEffect, useState } from "react";
import moment from "moment";

interface TimerDisplayProps {
  className?: string;
  timestamp: string;
  showLiveUpdate?: boolean;
}

const TimerDisplay: React.FC<TimerDisplayProps> = ({
  className,
  timestamp,
  showLiveUpdate = false,
}) => {
  const [, forceUpdate] = useState(0);

  useEffect(() => {
    if (!showLiveUpdate) return;

    const interval = setInterval(() => {
      forceUpdate((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [showLiveUpdate]);

  const getTimeAgo = (ts: string) => {
    if (!ts) return "--:--";
    const diffSec = moment().diff(moment(ts), "seconds");

    // if (diffSec < 30) return "Just now";

    // if (diffSec < 60) return `${diffSec} sec ago`;
    if (diffSec < 60) return "Just now";

    const diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) return `${diffMin} min${diffMin > 1 ? "s" : ""} ago`;

    const diffHr = Math.floor(diffMin / 60);
    if (diffHr < 24) return `${diffHr} hour${diffHr > 1 ? "s" : ""} ago`;

    const diffDay = Math.floor(diffHr / 24);
    if (diffDay < 7) return `${diffDay} day${diffDay > 1 ? "s" : ""} ago`;

    return moment(ts).format("MM/DD/YYYY hh:mm A");
  };

  if (!timestamp) return <span className={className}>--:--</span>;

  return <span className={className}>{getTimeAgo(timestamp)}</span>;
};

export default TimerDisplay;
